import { hnAPI } from '../../constants/api';
import { pageURL_HN } from '../../constants';
import fetchApi from '../../services/fetch';
import { getDocumentTypeHN } from 'utils/hnUtils';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  data: {},
  contractID: '',
};

export const clientInformation = {
  state: { ...initialState },
  reducers: {
    updateAgreementInformation(state, payload) {
      return {
        ...state,
        data: { ...state.data, ...payload },
      };
    },
    updateContractID(state, payload) {
      return {
        ...state,
        contractID: payload,
      };
    },
    clearCurrentInfo() {
      return {
        ...initialState,
      };
    },
    updateClientInfoValidateResponse(state, payload) {
      return {
        ...state,
        data: { ...state.data, clientInfoValidateResponse: payload },
      };
    },
  },
  effects: (dispatch) => {
    return {
      async getClientInformation({ callback, ...params }) {
        dispatch.apiStatus.setProcessing(true);
        this.clearCurrentInfo();
        fetchApi({
          method: 'POST',
          url: hnAPI.agreement,
          data: { ...params },
        })
          .then((response) => {
            this.updateAgreementInformation(response.data);
            const { agreementsList = {} } = response.data;
            if (agreementsList && agreementsList.length) {
              const isPending = agreementsList.some((agreement) =>
                agreement?.agreementItemsList?.some((item) => {
                  if (
                    !['submitted', 'in progress', 'completed', 'preactivated'].includes(
                      item?.orderStatus?.toLowerCase()
                    )
                  ) {
                    return true;
                  }
                })
              );
              if (isPending) {
                dispatch.apiStatus.setProcessing(false);
                callback(pageURL_HN.existingServices);
                return;
              }
              agreementsList.some((agreement) =>
                agreement?.agreementItemsList?.some((item) => {
                  if (
                    ['submitted', 'in progress', 'completed', 'preactivated'].includes(item?.orderStatus?.toLowerCase())
                  ) {
                    this.updateContractID(agreement.id);
                    return true;
                  }
                })
              );
              callback(pageURL_HN.activeTransaction);
            }
            dispatch.apiStatus.setProcessing(false);
          })
          .catch((error) => {
            if (error.errorCode === 404) {
              callback(pageURL_HN.locationServices);
              track(SERVER_RESPONSE_FAILED, {
                ...generateServerResponseError(
                  error,
                  ACTIVATION,
                  'Client Information',
                  hnAPI.agreement,
                  'Agreement API'
                ),
              });
              track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Agreement API') });
              return;
            }
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ACTIVATION, 'Client Information', hnAPI.agreement, 'Agreement API'),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Agreement API') });
          });
      },
      async clientInfoValiadte({ documentType, documentNumber, apiValidateCallback }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'get',
          url: `${hnAPI.clientInfoValiadte}?identificationType=${getDocumentTypeHN(
            documentType
          )}&identificationID=${documentNumber.replace(/ /g, '-')}`,
        })
          .then((response) => {
            const data = response.data;
            const hasDebt =
              [true, 'true'].includes(data?.individualsLists?.[0]?.customerAccountLists?.[0]?.hasDebt) ||
              data?.individualsLists?.[0]?.customerAccountLists?.[0]?.hasDebt?.toString()?.toLowerCase() === 'inc' ||
              false;
            dispatch.clientInformation.updateClientInfoValidateResponse(data);
            dispatch.apiStatus.setProcessing(false);
            apiValidateCallback(
              hasDebt,
              data?.individualsLists?.[0]?.customerAccountLists?.[0]?.hasDebt?.toString()?.toLowerCase() === 'inc'
            );
            return response;
          })
          .catch((error) => {
            if (error.errorCode === 404) {
              apiValidateCallback(false);
            } else {
              dispatch.apiStatus.setRequestFailed({ ...error });
            }
          });
      },
    };
  },
};
